import React from "react";

import NarratorForm from "./NarratorForm";
import { SummaryCard } from "../../../components/SummaryCard";

const AddNarrator = () => {
    return (
        <div className="page-content">
            <SummaryCard>
                <NarratorForm mode="add" />
            </SummaryCard>
        </div>
    );
};

export default AddNarrator;
